import { ChangeEvent, useEffect } from "react";
import { Box, MenuItem } from "@mui/material";
import { AppTextField, FormCore } from "src/Pages/components";
import { useMetricsContext } from "src/Contexts/Metrics/ContextMetrics";

import { UseFormGraphicProduction } from "./Hooks/UseFormGraphicProduction";
import { IFilterGraphicProduction } from "src/Contexts/Metrics/ContextMetricsTypes";

export const FormGraphicProduction = () => {
  const { filterGraphicProduction, setFilterGraphicProduction } =
    useMetricsContext();

  const { handleSubmit, loading } = UseFormGraphicProduction();

  const handleChange =
    (prop: keyof IFilterGraphicProduction) =>
      (event: ChangeEvent<HTMLInputElement>) => {
        setFilterGraphicProduction({
          ...filterGraphicProduction,
          [prop]: event.target.value,
        });
      };

  useEffect(() => {
    handleSubmit();
  }, []);

  return (
    <FormCore
      isNotCancel
      handleSubmit={handleSubmit}
      loadingSubmit={loading}
      marginTopButtons="0px"
      sxStyle={{
        margin: "0 0 12px 0",
        display: "flex",
        alignItems: "center",
      }}
      titleSubmit="Filtrar"
    >
      <Box sx={{ display: "flex", flexWrap: "wrap" }}>
        <AppTextField
          label="Inicio *"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={filterGraphicProduction?.start_date}
          variant="outlined"
          onChange={handleChange("start_date")}
        />
        <AppTextField
          label="Final *"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          type="date"
          value={filterGraphicProduction?.end_date}
          variant="outlined"
          onChange={handleChange("end_date")}
        />
        <AppTextField
          select
          id="tipo"
          label="Tipo *"
          sxStyle={{ width: "150px", opacity: "", pointerEvents: "auto" }}
          value={filterGraphicProduction?.interval}
          variant="outlined"
          onChange={handleChange("interval")}
        >
          <MenuItem value="DAY">Dia</MenuItem>
          <MenuItem value="WEEK">Semana</MenuItem>
          <MenuItem value="MONTH">Mês</MenuItem>
        </AppTextField>
      </Box>
    </FormCore>
  );
};
